import { dateRenderer, dateSorter } from '@/lib/generic.utils'
import AgGridToggle from '@components/ag-grid-helpers/AgGridToggle'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            filter: 'agTextColumnFilter',
            sortable: true
          },
          {
            headerName: 'Product type',
            field: 'product_type_name',
            filter: 'agTextColumnFilter',
            sortable: true
          },
          {
            headerName: 'Start date',
            field: 'start_date',
            comparator: dateSorter,
            filter: 'agTextColumnFilter',
            sortable: true,
            valueGetter: params => dateRenderer(params.data.start_date)
          },
          {
            headerName: 'End date',
            field: 'end_date',
            comparator: dateSorter,
            filter: 'agTextColumnFilter',
            sortable: true,
            valueGetter: params => dateRenderer(params.data.end_date)
          },
          {
            headerName: 'Publisher Name',
            field: 'publisher_name',
            filter: 'agTextColumnFilter',
            sortable: true
          },
          {
            headerName: 'Vendor Name',
            field: 'vendor_name',
            valueFormatter: params => params.value || 'N/A',
            filter: 'agTextColumnFilter',
            sortable: true
          },
          {
            headerName: 'Plan Workflow',
            field: 'plan_workflow',
            cellRendererParams: params => this.cellParams(params, 'plan_workflow'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('plan_workflow')
          },
          {
            headerName: 'Request Price',
            field: 'request_prices',
            cellRendererParams: params => this.cellParams(params, 'request_prices'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('request_prices')
          },
          {
            headerName: 'Price Entry',
            field: 'price_entries',
            cellRendererParams: params => this.cellParams(params, 'price_entries'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('price_entries')
          },
          {
            headerName: 'Stakeholders',
            field: 'stakeholders',
            cellRendererParams: params => this.cellParams(params, 'stakeholders'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('stakeholders')
          },
          {
            headerName: 'Evaluation',
            field: 'evaluations',
            cellRendererParams: params => this.cellParams(params, 'evaluations'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('evaluations')
          },
          {
            headerName: 'Decision',
            field: 'decisions',
            cellRendererParams: params => this.cellParams(params, 'decisions'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('decisions')
          },
          {
            headerName: 'Place Orders',
            field: 'place_orders',
            cellRendererParams: params => this.cellParams(params, 'place_orders'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('place_orders')
          },
          {
            headerName: 'Approve Invoices',
            field: 'approve_invoices',
            cellRendererParams: params => this.cellParams(params, 'approve_invoices'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('approve_invoices')
          },
          {
            headerName: 'Vendor Payments',
            field: 'vendor_payments',
            cellRendererParams: params => this.cellParams(params, 'vendor_payments'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('vendor_payments')
          },
          {
            headerName: 'Implementation',
            field: 'implementations',
            cellRendererParams: params => this.cellParams(params, 'implementations'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('implementations')
          },
          {
            headerName: 'Inform Users',
            field: 'inform_users',
            cellRendererParams: params => this.cellParams(params, 'inform_users'),
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => this.headerParams('inform_users')
          },
          {
            headerName: 'All Tasks',
            cellRendererParams: () => {
              return {
                getFromValue: true
              }
            },
            valueGetter: params => {
              return {
                val: this.isRowToggledToTrue(params),
                key: 'allTasks',
                onUpdate: this.toggleRow
              }
            },
            cellRendererFramework: AgGridToggle,
            pinnedRowCellRendererParams: () => ({
              hide: true
            })
          }
        ],
        onFilterChanged: params => {
          const cols = params.columnApi.columnController.gridColumns
          let filters = []
          Array.from({ length: 6 }, (_, index) => {
            filters.push(cols[index].filterActive)
          })
          const isLeastOneFilterEnabled = filters.some(filter => filter)
          this.areFiltersEnabled = isLeastOneFilterEnabled
        },
        rowData: null,
        domLayout: 'normal',
        enableCellChangeFlash: false,
        pagination: true,
        suppressScrollOnNewData: true,
        defaultColDef: {
          floatingFilter: true,
          filter: false,
          sortable: false,
          pinnedRowCellRendererFramework: AgGridToggle,
          pinnedRowCellRendererParams: () => ({
            hide: true
          }),
          suppressMenu: true
        },
        pinnedTopRowData: this.pinnedTopRowData
      }
    }
  }
}
